/*
 * brd-2026-quick-add.js
 *
 * AJAX quick-add for the brd-product-card snippet. Intercepts the submit on
 * forms with `data-brd-quick-add`, posts to /cart/add.js with section refresh
 * data so Dawn's <cart-drawer> custom element (already in this theme) updates
 * + opens automatically. Falls back to navigating to the product URL if the
 * fetch fails.
 *
 * Created: 2026-05-03
 */
(function () {
  'use strict';

  // Sections we ask Shopify to re-render in the response so we can update the
  // cart drawer and cart-icon bubble without a full page reload. These match
  // section file names in this theme.
  var REFRESH_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function getCartDrawer() {
    return document.querySelector('cart-drawer') ||
           document.querySelector('cart-notification') ||
           null;
  }

  function flashAdded(btn) {
    if (!btn) return;
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
  }

  function handleSubmit(e) {
    var form = e.target.closest('form[data-brd-quick-add]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.brd-product-card__cart');
    if (btn) btn.classList.add('is-loading');

    var formData = new FormData(form);
    formData.set('sections', REFRESH_SECTIONS.join(','));
    formData.set('sections_url', window.location.pathname);

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
    .then(function (res) {
      if (btn) btn.classList.remove('is-loading');

      if (!res.ok || (res.data && res.data.status && res.data.status >= 400)) {
        var msg = (res.data && (res.data.description || res.data.message)) || 'Unable to add to cart.';
        console.warn('brd-quick-add:', msg);
        // Fallback: navigate to the product page so the customer can resolve it.
        var productUrl = form.dataset.productUrl;
        if (productUrl) window.location.href = productUrl;
        return;
      }

      flashAdded(btn);

      // Refresh the cart drawer if present + open it.
      var drawer = getCartDrawer();
      if (drawer && res.data && res.data.sections && typeof drawer.renderContents === 'function') {
        try { drawer.renderContents(res.data); }
        catch (err) { console.warn('cart-drawer.renderContents failed:', err); }
      }
      if (drawer && typeof drawer.open === 'function') {
        try { drawer.open(); } catch (_e) { /* drawer.open expects an element on Dawn */ }
      }

      // Always broadcast a generic event so any listener (analytics, custom
      // bubble counter) can react.
      document.dispatchEvent(new CustomEvent('brd:cart-updated', {
        detail: { addedItemId: form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value }
      }));

      // If the drawer didn't auto-update, manually patch the cart bubble counts
      // by re-fetching cart.js and updating the existing cart count node(s).
      if (!drawer || !res.data.sections) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child')
            .forEach(function (el) { el.textContent = cart.item_count; });
        }).catch(function () { /* non-fatal */ });
      }
    })
    .catch(function (err) {
      if (btn) btn.classList.remove('is-loading');
      console.error('brd-quick-add error:', err);
      var productUrl = form.dataset.productUrl;
      if (productUrl) window.location.href = productUrl;
    });
  }

  // One delegated listener — cheaper than one per form, and survives
  // shopify:section:load DOM swaps automatically.
  document.addEventListener('submit', handleSubmit, false);
})();
